// react, react-redux, redux-form
import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, FormSection } from "redux-form";

// helpers
import { required, dateFormat } from "../../../helpers/validate";
import { fileUploaded } from "../../../helpers/actionsHelpers";
import { formatCurrencyDecimals, normalizeCurrency, jumpToError } from "../../../helpers/renderHelpers";

// redux actions
import { saveAppState } from "../../../actions/appActions";

// render components
import RenderField from "../../global/RenderField";

const feePayment = props => {
  const { formData, formName, attachments, handleSubmit, previousPage, saveAppState, appState, isAppSaving } = props;

  let feeWaiverPercentage = 0;

  if (formData.feeWaiver && formData.feeWaiver.length > 0) {
    formData.feeWaiver.forEach(item =>
      feeWaiverPercentage += parseFloat(item.percentageOfCost) || 0
    )
  }
  
  return (
    <form id={formName} onSubmit={handleSubmit}>
      { formData.feeWaiverOrExemption && formData.feeWaiverOrExemption !== 'notApplicable' ? (
        <div>
          <h2>Fee total</h2>
          <ul className="list">
            <li className="list-tile">
              <div className="list-tile-content">
                <div className="list-tile-content">
                  <p>Permit fee totalling <span style={{fontWeight: '600'}}>${formData.feePayable.toLocaleString()}</span>.</p>
                </div>
              </div>
            </li>
          </ul>
          <ul className="list">
            <li className="list-tile info">
              <div className="list-tile-content">
                {formData.feeWaiverOrExemption === 'exemption' ? (
                  <p>You are applying for a fee exemption. You will be required to upload the supporting document(s) on the next page for the fee exemption.</p>
                ) : (
                  <div>
                    <p>You are applying for a Fee Waiver. You will be required to upload the supporting document(s) on the next page respective to the fee waiver {formData.activity && formData.activity.length === 1 ? 'category' : 'categories'} that {formData.activity && formData.activity.length === 1 ? 'has' : 'have'} been selected.</p>
                    <p>You are applying for a fee waiver { feeWaiverPercentage > 0 && (<span>for <span style={{fontWeight: '600'}}>{feeWaiverPercentage.toFixed(2)}%</span></span>)} of the {formData.feePayable && (<span style={{fontWeight: '600'}}>${formData.feePayable.toLocaleString()}</span>)} permit fee.</p>
                  </div>
                )}
              </div>
            </li>
          </ul>
        </div>
      ) 
      : (
        <div>
          <h2>Fee payment</h2>
          <ul className="list">
            <li className="list-tile">
              <div className="list-tile-content">
                <div className="list-tile-content">
                  <p>Permit fee to be paid totalling <span style={{fontWeight: '600'}}>${formData.feePayable.toLocaleString()}</span>.</p>
                </div>
              </div>
            </li>
          </ul>
          <h3>Heritage victoria biller details</h3>
          <ul className="list">
            <li className="list-tile">
              <div className="list-tile-content columns-fixed">
                <p className="list-tile-content half">BPAY Biller Code:</p>
                <p className="list-tile-content half">72637</p>
                <p className="list-tile-content half">Customer Ref:</p>
                <p className="list-tile-content half">164123456786</p>
              </div>
            </li>
          </ul>
          <h3>Payment methods</h3>
          <ul className="list">
            <h4>BPAY</h4>
            <li className="list-tile">
              <div className="list-tile-content">
                  <div className="list-tile-content">
                    <span className="image bpay"></span>
                    <p>Telephone and Internet banking BPAY, Contact your bank or financial institution to make this payment from your cheque, savings, debit, credit card or transaction account.</p>
                    <p>More information can be found at: <a href="www.bpay.com.au" target="_blank" rel="noopener noreferrer">www.bpay.com.au</a></p>
                  </div>
              </div>
            </li>
          </ul>
          <h3>Payment receipt</h3>
          <ul className="list">
            <li className="list-tile info">
              <div className="list-tile-content">
                <p>To proceed beyond this point you are required to add proof of payment details and upload a copy of the receipt.</p>
                <p>If you wish to obtain the receipt of payment by leaving this form. We recommend you save and exit now. An email will be sent to the primary contact email address where you can retrieve this application.</p>
                <button type="button" className="sq-form-page-button" onClick={() => saveAppState(appState, formName)} disabled={isAppSaving || fileUploaded(attachments)}>Save and Exit</button>
              </div>
            </li>
          </ul>
          <FormSection name="paymentReceipts[0]">
            <Field
              name="type"
              type="radiobox"
              label="Which payment method do you have a receipt for?"
              component={RenderField}
              templateList={[
                { name: "BPAY receipt", value: "bpay" }
              ]}
              validate={required}
              required
            />
            { formData.paymentReceipts && formData.paymentReceipts[0].type && (
              <ul className="list">
                <li className="list-tile info">
                  <div className="list-tile-content">
                    <p>You will be required to upload the receipt(s) on the next page. Please retain the receipt for future reference.</p>
                  </div>
                </li>
              </ul>
            )}
            { formData.paymentReceipts && formData.paymentReceipts[0].type && formData.paymentReceipts[0].type === 'bpay' && (
              <div>
                <h4>BPAY receipt details</h4>
                <div className="sq-form-section">
                  <Field
                    name="amountPaid"
                    type="text"
                    label="Amount paid"
                    component={RenderField}
                    format={formatCurrencyDecimals}
                    normalize={normalizeCurrency}
                    validate={required}
                    required
                    width="half"
                  />
                  <Field
                    name="bankName"
                    type="text"
                    label="Your bank name"
                    component={RenderField}
                    validate={required}
                    required
                    width="half"
                  />
                  <Field
                    name="receiptNumber"
                    type="text"
                    label="Receipt number"
                    component={RenderField}
                    validate={required}
                    required
                    width="half"
                  />
                  <Field
                    name="receiptDate"
                    type="text"
                    label="Receipt date"
                    placeholder="dd/mm/yyyy"
                    component={RenderField}
                    validate={[required, dateFormat]}
                    required
                    width="half"
                  />
                </div>
              </div>
            )}
          </FormSection>
        </div>
      )}
      <div className="sq-form-control">
        <button type="button" className="sq-form-page-button previous" onClick={previousPage}>Previous</button>
        <button type="submit" className="sq-form-page-button next" onClick={jumpToError}>Next</button>
      </div>
      <div className="sq-form-control">
        <button type="button" className="sq-form-page-button" onClick={() => saveAppState(appState, formName)} disabled={isAppSaving || fileUploaded(attachments)}>Save and Exit</button>
        <p className="sq-form-page-button-note">An email will be sent to Primary contact email address</p>
      </div>
    </form>
  );
};

const mapStateToProps = (state, formName) => {
  return {
    formData: (state.form[formName.form]) ? state.form[formName.form].values : {},
    attachments: state.service.attachments,
    isAppSaving: state.app.isAppSaving,
    appState: state        
  };
};

const mapDispatchToProps = {
  saveAppState
};

const form = reduxForm({
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true // <------ unregister fields on unmount
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)((form)(feePayment));
